import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";

export function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const params = useParams();
    return <Component {...props} params={params} />;
  };
}

export function withNavigation(Component) {
  return function ComponentWithNavigation(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export function withLocation(Component) {
  return function ComponentWithLocation(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}

export function withOutletProps(Component) {
  return function ComponentWithOutletContext(props) {
    const outletProps = useOutletContext();
    return <Component {...props} {...outletProps} />;
  };
}

export function withOutletPropsAndNavigation(Component) {
  return function ComponentWithOutletContextAndNavigation(props) {
    const outletProps = useOutletContext();
    const navigate = useNavigate();
    return <Component {...props} {...outletProps} navigate={navigate} />;
  };
}

export function withRouterAndLocation(Component) {
  return function ComponentWithRouterPropAndLocation(props) {
    const params = useParams();
    const location = useLocation();
    return <Component {...props} params={params} location={location} />;
  };
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export function withRouterProps(Component) {
  return function ComponentWithNewRouter(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const outletProps = useOutletContext();
    return (
      <Component {...props} router={{ params, location, navigate, outletProps }} />
    );
  };
}